<template>
<div class="chapter">
<div class="inner_page">
<div class="toc" id="toc">
<h1 class="toc">Contents</h1>
<p class="toc"><a class="hlink" href="#/OEBPS/9780795320729_epub_c01_r1.htm"><em>Chapter One</em></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/9780795320729_epub_c02_r1.htm"><em>Chapter Two</em></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/9780795320729_epub_c03_r1.htm"><em>Chapter Three</em></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/9780795320729_epub_c04_r1.htm"><em>Chapter Four</em></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/9780795320729_epub_c05_r1.htm"><em>Chapter Five</em></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/9780795320729_epub_c06_r1.htm"><em>Chapter Six</em></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/9780795320729_epub_c07_r1.htm"><em>Chapter Seven</em></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/9780795320729_epub_c08_r1.htm"><em>Chapter Eight</em></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/9780795320729_epub_c09_r1.htm"><em>Chapter Nine</em></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/9780795320729_epub_c10_r1.htm"><em>Chapter Ten</em></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/9780795320729_epub_c11_r1.htm"><em>Chapter Eleven</em></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/9780795320729_epub_c12_r1.htm"><em>Chapter Twelve</em></a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/9780795320729_epub_c13_r1.htm"><em>Chapter Thirteen</em></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795320729_epub_toc_r1.vue?bff092b4